import { StorageKeys } from '@base/utils/constants';
import { ILocalStorage } from '../../storage/interfaces';
import API_PATHS from '../constants/apiPaths';

export interface IApiClient {
  post(params: Record<string, any>, path: API_PATHS): Promise<Response>;
  get(params: Record<string, any>, path: API_PATHS): Promise<Response>;
  authPost(params: Record<string, any>, path: API_PATHS): Promise<Response>;
  authGet(params: Record<string, any>, path: API_PATHS): Promise<Response>;
}

class ApiClient implements IApiClient {
  private DEFAULT_HEADERS = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  constructor(private url: string, private localStorage: ILocalStorage) {}

  async authGet(params: Record<string, any>, path: API_PATHS): Promise<Response> {
    const { usr, session } = this.localStorage.get(StorageKeys.SESSION);
    return await this.sendRequest('GET', { ...params, usr, sid: Number(session) }, path);
  }

  async get(params: Record<string, any>, path: API_PATHS, authRequired?: boolean) {
    return await this.sendRequest('GET', params, path);
  }

  async authPost(params: Record<string, any>, path: API_PATHS): Promise<Response> {
    const { usr, session } = this.localStorage.get(StorageKeys.SESSION);
    return await this.sendRequest('POST', { ...params, usr, sid: Number(session) }, path);
  }

  async post(params: Record<string, any>, path: API_PATHS, authRequired?: boolean) {
    return await this.sendRequest('POST', params, path);
  }

  private async sendRequest(
    method: 'POST' | 'GET',
    params: Record<string, any>,
    path: string
  ): Promise<Response> {
    const queryParams = new URLSearchParams(params as Record<string, string>);
    const url = new URL(path ? this.url + path : this.url);
    const options: RequestInit = {
      method,
      headers: this.DEFAULT_HEADERS,
    };
    method === 'POST' ? (options.body = queryParams) : (url.search = queryParams.toString());
    return await fetch(url.toString(), options);
  }
}

export default ApiClient;
